import MyTasks from "@/components/MyTasks";
import FinishedVideos from "@/components/FinishedVideos";
import { SessionContext } from "@/context/SessionContext";
import { Box, Stack, Text, useMantineTheme, Tabs } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import React, {
	useContext,
	useRef,
	useState,
} from "react";

const InstrumentalistInterface: React.FC = () => {
	// mt - My Tasks, fv - Finished Videos
	const [activeTab, setActiveTab] = useState<string>("mt");

	const theme = useMantineTheme();
	const session = useContext(SessionContext);
	const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
	const fzLarge = isMobile ? 20 : 30;
	const fzActiveTab = isMobile ? 18 : 20;
	const fzInactiveTab = isMobile ? 18 : 15;

	const dashboardRef = useRef<HTMLDivElement>(null);

	if (!session) {
		return null;
	}

	return (
		<Stack ref={dashboardRef} align="center" justify="center" w="100%">
			{/* Header */}
			<Text
				p={20}
				pb={0}
				fz={fzLarge}
				c={theme.colors.blue[0]}
				ta="center"
				style={{
					minWidth: "300px",
					whiteSpace: "nowrap",
				}}
			>
				Instrumentalist Interface
			</Text>
			{/* TABS */}
			<Tabs
				value={activeTab}
				onChange={(value) => setActiveTab(value || "mt")}
				// width of dark box on screen
				w={"90%"}
				keepMounted
				styles={{
					list: {
						borderBottom: theme.colors.blue[3],
					},
					panel: {
						border: "none",
					},
				}}
			>
				<Tabs.List>
					<Tabs.Tab
						// my tasks tab width
						w={isMobile ? "50%" : 150}
						value="mt"
						bg={activeTab === "mt" ? theme.colors.blue[8] : theme.colors.blue[3]}
						c={theme.colors.blue[8]}
						fw={700}
						fz={activeTab === "mt" ? fzActiveTab : fzInactiveTab}
						bd={"none"}
						style={{
							"&:hover": {
								backgroundColor:
									activeTab === "mt" ? theme.colors.blue[8] : theme.colors.blue[4],
							},
						}}
					>
						{/* My Tasks - tab text */}
						<Text
							fz={activeTab === "mt" ? fzActiveTab : fzInactiveTab}
							c={activeTab === "mt" ? theme.colors.blue[0] : theme.colors.blue[8]}
						>
							My Tasks
						</Text>
					</Tabs.Tab>
					<Tabs.Tab
						// width of my performances tab
						w={isMobile ? "50%" : 230}
						value="fv"
						bg={activeTab === "fv" ? theme.colors.blue[8] : theme.colors.blue[3]}
						c={theme.colors.blue[8]}
						bd={"none"}
						fw={700}
						style={{
							"&:hover": {
								backgroundColor:
									activeTab === "fv" ? theme.colors.blue[8] : theme.colors.blue[4],
							},
						}}
					>
						<Text
							fz={activeTab === "fv" ? fzActiveTab : fzInactiveTab}
							c={activeTab === "fv" ? theme.colors.blue[0] : theme.colors.blue[8]}
						>
							{isMobile ? "My Videos" : "My Performances"}
							{/* My Videos - looks better on mobile, same length phrase as My Tasks,
                                doesn't matter as much on desktop bc there's so much space */}
						</Text>
					</Tabs.Tab>
				</Tabs.List>

				{/* My Tasks Tab */}
				<Tabs.Panel value="mt">
					<Box
						// width of dark box
						w="100%"
						h="100%"
						mx="auto"
						style={{ borderRadius: "0px 0px 15px 15px", overflow: "hidden" }}
						bg={theme.colors.blue[8]}
					>
						<Box
							// w and p together center my tasks in box
							w={"100%"}
							p={isMobile ? 15 : 30}
						>
							<MyTasks />
						</Box>
					</Box>
				</Tabs.Panel>

				{/* Finished videos Tab */}
				<Tabs.Panel value="fv">
					<Stack
						// width of dark box
						w="100%"
						mx="auto"
						style={{ borderRadius: "0px 0px 15px 15px", overflow: "hidden" }}
						bg={theme.colors.blue[8]}
					>
						<Box
							// w and p together center my performances in box
							w={"100%"}
							p={isMobile ? 15 : 30}
						>
							<FinishedVideos />
						</Box>
					</Stack>
				</Tabs.Panel>
			</Tabs>
		</Stack>
	);
};

export default InstrumentalistInterface;
